export const version = '1.0.7';
//# sourceMappingURL=version.js.map